import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/user-auth`;
const TOKEN_KEY = "sf_user_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const apiLogin = (id_token) =>
  axios.post(`${API}/login`, { id_token }).then((r) => r.data);

export const apiMe = () =>
  axios.get(`${API}/me`, { headers: authHeader() }).then((r) => r.data);

export const apiUpdateMe = (body) =>
  axios.patch(`${API}/me`, body, { headers: authHeader() }).then((r) => r.data);

export const apiLogout = () =>
  axios.post(`${API}/logout`, {}, { headers: authHeader() }).then((r) => r.data);

export const apiMyBookings = () =>
  axios.get(`${API}/bookings`, { headers: authHeader() }).then((r) => r.data);

export const apiLinkBooking = (body) =>
  axios.post(`${API}/bookings/link`, body, { headers: authHeader() }).then((r) => r.data);
